//create ./config.local.js file with parameters and this patterns:
// export const API_HOST = 'http://localhost:8000';

import * as LOCAL from './config.local.js';

export const API_HOST = LOCAL.API_HOST;